<template>
    <div class="maskedView">
        <div v-for="(item,i) in limitnumFun" :key="i" :class="limitnumFun>1 && i === (limitnumFun-1)?'masked half':'masked'"></div>
    </div>

</template>

<script>
  export default {
    name: 'skeletonView',
    props: {
      h: {
        type: Number,
        default: 0
      },
    },

    data: function () {
      return {
      }
    },

    created: function () {
      // console.log(this.h)
    },

    mounted: function () {

    },

    beforeUnmount: function () {
    },
    computed: {
      limitnumFun: function(){
        let num = parseInt(this.h/5.5)
        console.log("this.h",this.h);
        return num
      }
    },

    methods: {


    }
  }
</script>

<style lang="scss" scoped>
  .maskedView {
    width: 100%;
    height: 100%;
  }
  @media all and (-webkit-min-device-pixel-ratio:0) and (min-resolution: .001dpcm) {
    .masked{
      width: 100%;
      height: 40px;
      margin-top: 17px;
      background-image: -webkit-linear-gradient(left, #F3F3F2,#EBEBEB);
      -webkit-text-fill-color: transparent;
      -webkit-background-clip: content-box;
      -webkit-background-size: 200% 100%;
      -webkit-animation: masked-animation 1.2s infinite cubic-bezier(0,0.2,0.5,1);
      &.half {
        width: 50%;
      }
    }
  }
  @keyframes masked-animation {
    0%  {
      background-position: 0 0;
    }
    100% {
       background-position: -100% 0
    }
  }
</style>
